<template>
  <b-container>
    <h1>{{ $t("vehicle.edit") }}</h1>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />

    <b-row class="mb-3 ml-0">
      <router-link :to="getUrlBackToList">
        <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
      </router-link>
    </b-row>
    <b-row>
      <b-col sm="12" md="6" lg="6">
        <vehicle-registration-crud
          ref="crudData"
          :model="model"
          :modelstate="modelstate"
          :allType="allType"
        ></vehicle-registration-crud>
      </b-col>
    </b-row>
    <!-- {{ model }} -->
    <b-button @click="save()" type="submit" :disabled="submitted">
      {{ $t("geral.save") }}
    </b-button>
  </b-container>
</template>
<script>
export default {
  name: "VehicleEdit",
  props: {
    id: String
  },
  components: {
    VehicleRegistrationCrud: () =>
      import(
        "@/components_rms/vehicle/Registration/VehicleRegistrationCrud.vue"
      ),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue")
  },
  created() {
    this.loadData();
    this.getAllVehicleType();
  },
  computed: {
    getUrlBackToList() {
      return `../list`;
    }
  },
  data() {
    return {
      alert: {
        error: "",
        success: this.$t("vehicle.editSuccess")
      },
      submitted: false,
      model: {},
      modelstate: {},
      allType: []
    };
  },

  methods: {
    loadData() {
      this.$apiVehicle
        .get("/vehicleRegistration/getById/" + this.id)
        .then(response => {
          this.model = response.data;
          this.modelstate = {};
          //   this.$refs.crudData.refreshData();
        })
        .catch(error => {
          this.submitted = false;

          console.log(error);
          console.log(error.response);
          console.log(error.errorCode);

          switch (error.response.status) {
            case 401:
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
              break;
            case 400:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = error.response.data.errors;
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
            default:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = {};
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
          }
        });
    },
    getAllVehicleType() {
      this.$apiVehicle.get("/vehicleType/listAllType/").then(response => {
        this.allType = response.data;
        this.allType.forEach(type => {
          this.vehicleTypeOpt.push({
            value: type.id,
            text: type.name
          });
        });
      });
    },
    save() {
      this.submitted = true;
      console.log(this.model);
      this.$apiVehicle
        .post("/vehicleRegistration/edit/", this.model)
        .then(response => {
          this.submitted = false;
          this.modelstate = {};
          this.$refs.alert.show();
        })
        .catch(error => {
          this.submitted = false;

          console.log(error);
          console.log(error.response);
          console.log(error.errorCode);

          switch (error.response.status) {
            case 401:
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
              break;
            case 400:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = error.response.data.errors;
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
            default:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = {};
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
          }
        });
    }
  }
};
</script>
